import React from 'react';
import { postData, setPayload } from '../../helper';
import { ErrorToastComponent as ErrorToast } from '../../components/Toasts';

class LoginForm extends React.Component {
    constructor(props) {
        super();
        this.state = {
            email_id: '',
            otp: '',
            err_message: null
        }
        this.submitHandler = this.submitHandler.bind(this);
    }

    componentDidMount() {

    }

    onChangeHandler = (e) => {
        try {
            this.setState({
                [e.target.name]:e.target.value,
                err_message: ''
            });
        } catch(err) {
            throw new Error(err.message);
        }
    }

    async submitHandler(e) {
        try {
            e.preventDefault();

            const self = this;
            if(self.state.otp.length === 0) return; 

            const response = await postData('/auth/verify',{
                verification_otp: self.state.otp,
                email_id: self.state.email_id
            });

            if(response.error && response.error.message)
                this.setState({err_message: response.error.message});
            else {
                if(response.data) {
                    const responseData = response.data;
                    if(responseData.verified)
                        setPayload(responseData.verified, 'verified');
                    if(responseData.user && responseData.user.info)
                        setPayload(responseData.user.info, 'user');
                    if(responseData.user && responseData.user.access_token) 
                        setPayload(responseData.user.access_token, 'access_token');
                }
                window.location.href='/dashboard';
                return;
            }

        } catch(err) {
            throw new Error(err.message);
        }
    }

    renderErrorToast = () => {
        try {
            if(!this.state.err_message) return '';
            return <ErrorToast message={this.state.err_message}/>
        } catch(err) {
            return err.message;
        }
    }

    renderEmailField = () => {
        try {
            if(this.props.emailRequired === 'yes') {
                return (
                    <div className="form-group">
                        <input type="email" className="form-control form-control-user"
                            id="inputEmail" aria-describedby="emailHelp"
                            placeholder="Enter Email Address..." value={this.state.email_id} 
                            name='email_id' onChange={this.onChangeHandler}/>
                    </div>
                );
            }
            return '';
        } catch(err) {
            return '';
        }
    }

    render() {
        return (
            <>
                <form className="user">
                    <div className="form-group">
                        {this.renderEmailField()}
                        <input type="number" className="form-control form-control-user"
                            id="inputOTP" aria-describedby="otpHelp"
                            placeholder="Verification OTP" value={this.state.otp} 
                            name='otp' onChange={this.onChangeHandler}/>
                    </div>
                    {this.renderErrorToast()}
                    <button type="button" className="btn btn-primary btn-user btn-block" onClick={this.submitHandler}>
                        Verify
                    </button>
                </form>
            </>
        );
    }

}

export default LoginForm;